<template>
    <!-- Section - Resume -->
    <section class="lui-section lui-gradient-bottom" id="resume-section">

        <!-- Heading -->
        <div class="lui-heading">
            <div class="container">

                <div class="m-titles align-center">
                    <h2 class="m-title splitting-text-anim-1 scroll-animate" data-splitting="words" data-animate="active">
                        <span> Resume </span>
                    </h2>
                    <div class="m-subtitle splitting-text-anim-1 scroll-animate" data-splitting="words" data-animate="active">
                        <span> my <b>Story</b></span>
                    </div>
                </div>

            </div>
        </div>

        <!-- History -->
        <div class="v-line v-line-left">
            <div class="container">

                <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">

                        <h5 class="history-title scrolla-element-anim-1 scroll-animate" data-animate="active">
                            <span> Education </span>
                        </h5>
                        <div class="history-items" v-for="item in educationalItems" :key="item.id">
                            <div class="history-item lui-collapse-item scrolla-element-anim-1 scroll-animate" data-animate="active">
                                <h6 class="name lui-collapse-btn">
                                    <span> {{item.education_name}}</span>
                                </h6>
                                <div class="history-content">
                                    <div class="subname">
                                        <span> {{ item.major }} </span>
                                    </div>
                                    <div class="date lui-subtitle">
                                        <span> {{ item.start_year }} - {{item.end_year}} </span>
                                    </div>
                                    <div class="text">
                                        <div>
                                            <p>{{ item.education_description }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>

                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">

                        <h5 class="history-title scrolla-element-anim-1 scroll-animate" data-animate="active">
                            <span> Experience </span>
                        </h5>
                        <div class="history-items">
                            <div class="history-item lui-collapse-item scrolla-element-anim-1 scroll-animate" data-animate="active">
                                <h6 class="name lui-collapse-btn">
                                    <span> Web Developer Intern at Ciptadrasoft </span>
                                </h6>
                                <div class="history-content">
                                    <div class="subname">
                                        <span> PT. Ciptradra Softindo </span>
                                    </div>
                                    <div class="date lui-subtitle">
                                        <span> Jan 2020 - Aug 2020</span>
                                    </div>
                                    <div class="text">
                                        <div>
                                            <p>During my web developer internship at Ciptadra Softindo, I gained hands-on experience with the following technologies and methodologies:</p>

                                                <ul>
                                                <li>Tech Stack: CodeIgniter 3, PHP, CSS, HTML, Bootstrap, jQuery, Laravel, GitLab.</li>
                                                <li>CodeIgniter 3: Used this PHP framework with MVC architecture for dynamic and scalable web application development.</li>
                                                <li>PHP, HTML, CSS: Leveraged these languages to handle server-side scripting, build web page structure, and design visually appealing interfaces.</li>
                                                <li>Bootstrap: Implemented the CSS framework for responsive and mobile-friendly web design.</li>
                                                <li>jQuery: Utilized the JavaScript library for simplified client-side scripting and enhanced user interactions.</li>
                                                <li>Laravel: Gained exposure to this PHP web application framework and its modern development patterns.</li>
                                                <li>GitLab: Employed as the version control system for efficient code collaboration and management.</li>
                                                <li>Scrum Methodology: Followed agile project management practices, including daily stand-ups, sprint planning, and retrospectives.</li>
                                                </ul>

                                                <p>Overall, my internship at Ciptadra Softindo allowed me to work with a diverse tech stack, collaborate with a talented team, and gain practical experience in web development using industry-standard tools and methodologies.</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="history-item lui-collapse-item scrolla-element-anim-1 scroll-animate" data-animate="active">
                                <h6 class="name lui-collapse-btn">
                                    <span> Mobile App Developer at PT Redcorp Indonesia </span>
                                </h6>
                                <div class="history-content">
                                    <div class="subname">
                                        <span> PT Redcorp Indonesia </span>
                                    </div>
                                    <div class="date lui-subtitle">
                                        <span> May 2022 - Aug 2022 </span>
                                    </div>
                                    <div class="text">
                                        <div>
                                            <p>During my time as a mobile app developer at PT Redcorp Indonesia, I primarily worked with Flutter, a versatile framework for building cross-platform mobile applications. I utilized GitHub as our version control system, ensuring smooth collaboration and efficient code management.</p>

                                            <p>To enhance the user experience, I crafted seamless interfaces and engaging animations using Flutter. Additionally, I leveraged Firebase and Firestore to incorporate powerful backend functionalities, including real-time data synchronization and secure user authentication.</p>

                                            <p>In addition to mobile app development, I also gained experience in Flutter web, enabling me to create responsive web interfaces and manage backend functionalities.</p>

                                            <p>Overall, my experience at PT Redcorp Indonesia sharpened my skills in mobile app development using Flutter, while also exposing me to efficient version control practices through GitHub. Additionally, integrating Firebase and Firestore expanded my capabilities in building robust and feature-rich mobile applications.</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="history-item lui-collapse-item scrolla-element-anim-1 scroll-animate" data-animate="active">
                                <h6 class="name lui-collapse-btn">
                                    <span> Jr. Web Developer at PT Van Aroma </span>
                                </h6>
                                <div class="history-content">
                                    <div class="subname">
                                        <span> PT. Van Aroma </span>
                                    </div>
                                    <div class="date lui-subtitle">
                                        <span> Aug 2022 - Present </span>
                                    </div>
                                    <div class="text">
                                        <div>
                                            <p>During my role as a Web Developer Junior at PT Van Aroma, I had the opportunity to work with a comprehensive tech stack that included Laravel, CodeIgniter 3, CodeIgniter 4, native PHP, SQL, REST API, Vue.js, and Google APIs.</p>
                                            <br>
                                            <p>One of the significant highlights of my experience was integrating various Google APIs into the company's main ERP system. Using my skills in Laravel, CodeIgniter, and native PHP, I successfully implemented functionalities that seamlessly integrated Google Sheets, Google Translate, and Google Finance into the ERP system. This allowed for efficient data management, multilingual support, and real-time currency conversion within the application.</p>
                                            <br>
                                            <p>In addition to the Google API integrations, I utilized Laravel and CodeIgniter to develop and maintain web applications. Leveraging the power of these frameworks, I created robust and scalable solutions that provided seamless user experiences and efficient data processing.</p>
                                            <br>
                                            <p>To manage and retrieve data effectively, I worked with SQL, ensuring data integrity and optimizing information retrieval processes. Furthermore, I utilized REST APIs to facilitate communication between different systems, enabling smooth data exchange and integration.</p>
                                            <br>
                                            <p>Moreover, I leveraged Vue.js to enhance the user interfaces of web applications, creating interactive and responsive front-end experiences. This added an extra layer of interactivity and improved overall user experience within the ERP system.</p>
                                            <br>
                                            <p>Overall, my experience at PT Van Aroma as a Web Developer Junior involved utilizing a comprehensive tech stack, including Laravel, CodeIgniter, native PHP, SQL, REST API, Vue.js, and integrating Google APIs. These integrations extended the functionality of the ERP system, enhancing data management, multilingual support, and real-time currency conversion capabilities. Working with this tech stack allowed me to develop efficient and user-friendly web applications that contributed to the success of the company.</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>

                </div>
            </div>

            <div class="lui-bgtitle">
                <span> History </span>
            </div>

            </div>
        </div>

    </section>
</template>

<script>
export default {
    name: "ResumeComponents",
    data() {
        return {
            educationalItems : [
                {
                    'id' : 1,
                    'education_type' : 'High School',
                    'education_name' : 'SMKN 1 Depok',
                    'major' : 'Software Engineering',
                    'start_year' : 2019,
                    'end_year' : 2022,
                    'education_description' : "I went to SMKN 1 Depok, where I pursued a major in Software Engineering. During my time there, I learned about coding and gained a solid understanding of fundamental concepts."

                },
                {
                    'id' : 2,
                    'education_type' : 'College',
                    'education_name' : 'IPWIJA University',
                    'major' : 'Software Engineering',
                    'start_year' : 2023,
                    'end_year' : 2027,
                    'education_description' : "I'm currently enrolled in college at IPWIJA University, where I'm majoring in Software Engineering. This program is helping me deepen my skills in the world of programming."

                },
            ],
            workExperienceItems: []
        }
    }
}
</script>
